module.exports = __webpack_public_path__ + "img/icon_map_62_off_100.8cc0ee36.png";